import axios from "axios";
import { baseApiUrl, getHttpHeaders, httpRequest } from "./ApiUtils";

const profileApiUrl = `${baseApiUrl}/api/Profile`;

export async function getUserProfile() {
    return await httpRequest(fetchUserProfile.bind(this));
}

async function fetchUserProfile() {
    let config = getHttpHeaders();
    return await axios.get(`${profileApiUrl}`, config);
}

export async function updateUserProfile(profile) {
    return await httpRequest(putUserProfile.bind(this, profile));
}

async function putUserProfile(profile) {
    let config = getHttpHeaders();
    return await axios.put(`${profileApiUrl}`, profile, config);
}

export async function getUserProfileImage() {
    return await httpRequest(fetchUserProfileImage.bind(this));
}

async function fetchUserProfileImage() {
    let config = getHttpHeaders();
    return await axios.get(`${profileApiUrl}/Image`, config);
}

export async function updateUserProfileImage(data) {
    return await httpRequest(putUserProfileImage.bind(this, data));
}

async function putUserProfileImage(data) {
    let config = getHttpHeaders();
    return await axios.put(`${profileApiUrl}/Image`, data, config);
}
